import React from 'react';

const DialogContext = React.createContext();

export default DialogContext;